export default "/images/vendor/flag-icon-css/flags/4x3/zw.svg?cd37458b29efc0063ff64339b2923a8f";